<template>
  <!-- Modal repartidores -->
  <b-modal id="asignar-repartidor-modal" hide-footer ref="repartidores-modal">
    <template v-slot:modal-title>
      <div class="input-group mb-0">
        <div class="input-group-prepend">
          <span class="input-group-text" id="basic-addon1">
            Seleccione repartidor
          </span>
        </div>
        <input
          type="text"
          class="form-control"
          v-model="search"
          placeholder="nombre del repartidor"
        />
      </div>
    </template>
    <div class="d-block" v-if="pedido_aux">
      <div class="list-group" id="lista-repartidores" :style="style_list">
        <a
          v-for="(r, i) in repartidores_filter"
          class="list-group-item list-group-item-action"
          style="padding:2px 10px"
          @click="activar(i)"
          :class="{ active: i == active }"
          :key="r.name"
        >
          {{ r.name }}
        </a>
      </div>
    </div>
    <div class="row">
      <div class="col-sm">
        <button
          class="btn btn-secondary btn-dark btn-block"
          @click="$bvModal.hide('asignar-repartidor-modal')"
        >
          Cerrar
        </button>
      </div>
      <div class="col-sm">
        <button
          class="btn btn-primary btn-block"
          @click="asignar_pedido"
          :class="{ 'btn-secondary': active == -1 }"
        >
          Asignar
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import Pedido from "@/apis/Pedido";
import User from "@/apis/User";

export default {
  props: {
    pedido_aux: {
      type: Object,
      required: true
    }
  },
  model: {
    prop: "pedido_aux",
    event: "change"
  },
  data() {
    return {
      search: "",
      active: -1,
      repartidores: [],
      style_list: "height: 300px"
    };
  },
  created() {},
  mounted() {
    this.$nextTick(function() {
      window.addEventListener("resize", this.resize);
      this.resize();
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resize);
  },
  methods: {
    resize: function() {
      let barra = document.getElementById("barra-superior");
      if (barra == null) {
        return (this.style_list = "height: 300px");
      }
      let btop = document.getElementById("barra-superior").offsetHeight + 150;
      let h = window.innerHeight - btop;
      this.style_list = `height: ${h}px`;
    }, // resize
    activar: function(index) {
      if (this.active == index) {
        return (this.active = -1);
      }
      this.active = index;
    },
    estado_icon: function(edo) {
      return "fas " + this.status[edo];
    },
    mostrar_repartidores: function(pedido) {
      this.pedido_aux = pedido;
      this.$bvModal.show("asignar-repartidor-modal");
      if (this.repartidores.length > 0) {
        return;
      }
      User.repartidores_list().then(response => {
        this.repartidores = response.data;
      });
    },
    asignar_pedido: function() {
      let data = {
        pedido_id: this.pedido_aux.id,
        cobrador_id: this.repartidores_filter[this.active].id
      };
      Pedido.asignar_repartidor(data).then(() => {
        this.$emit("asignar-pedido", data.data);
      });
      this.$bvModal.hide("asignar-repartidor-modal");
    },
    cobrar_y_finalizar: function(pedido_id) {
      // mostrar_repartidores(pedido.row)
      Pedido.cobrar_y_finalizar(pedido_id).then(e => {
        alert(JSON.stringify(e.data));
        location.reload();
      });
    }
  }, // end methods
  computed: {
    repartidores_filter: function() {
      if (this.search == "") {
        return this.repartidores;
      }
      return this.repartidores.filter(
        e => e.name.toLowerCase().indexOf(this.search.toLowerCase()) != -1
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.produccion,
.reparto,
.cobro,
.finalizado {
  color: white;
  background-color: #666;
  padding: 0.375rem 0.75rem !important;
}

.produccion {
  background-color: #c45900;
}
.reparto {
  background-color: #a21525;
}
.cobro {
  background-color: #800097;
}
.finalizado {
  background-color: #043cec;
}
.modal-body {
  padding-top: 0 !important;
}
</style>
